export default {
  application: {
    title: 'Holísticus',
    exit: 'Exit',
    create: 'Create',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    back: 'Back',
    delete: 'Inactive',
    remove: 'Delete',
    edit: 'Edit',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    date: {
      long: 'MMMM Do, YYYY',
      short: 'MM/DD/YYYY',
    },
    languages: {
      pt_BR: 'Portuguese',
      en: 'English',
    },
    reset_pass: 'Reset Password',
    errors_found_in: 'Found errors in',
    errors_found: 'Found errors',
    conclude: 'Conclude',
    recovery_pass: 'Recovery Pass',
    success: 'Success',
    redirecting: 'Redirecting',
    new: 'New',
  },
  fields: {
    attachment: 'Attachment',
    name: 'Name',
    no_attachment: 'No file attached',
    cnpj: 'CNPJ',
    workflow_name: 'Workflow Name',
  },
  button: {
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    back: 'Back',
    add: 'Add',
    search: 'Search',
    view: 'View',
    add_dynamic_fields: 'Add Dynamic Fields',
  },
  messages: {
    success_operation: 'Operation success !',
    confirm_exit: 'Do you really want to exit the system ?',
    confirm_delete: 'Do you really want inactivate this register ?',
    confirm_remove: 'Do you really want remove this register ?',
    required_field: 'This field is required !',
    invalid_email: 'This e-mail is invalid !',
    invalid_cpf: 'This cpf is invalid !',
    loading_data: 'Loading data, please wait ...',
    saving_data: 'Saving data, wait ...',
    deleting_data: 'Inactivating data, wait ...',
    removing_data: 'Removing data, wait ...',
    success_delete_data: 'Data has been deleted !',
    password_not_equals: 'The password is not equals',
    changing_pass: 'Changing password ...',
    ask_forgot_pass: 'Forgot your pass ?',
    account_not_exists: 'E-mail não encontrado',
    recovery_email_has_been_sent: 'In a moment you will receive an email with a link to change the password.',
    success_change_password: 'The password was updated successfully !',
    error_change_password: 'The password wasn\'t updated. ',
    activating_data: 'Activating data ...',
    inactivating_data: 'Inactivating data ...',
    blocking_data: 'Blocking data ...',
    unblocking_data: 'Unblocking data ...',
    standby_data: 'Saving standby ...',
    unexpected_error: 'Unexpected Error',
    invalid_less_date: 'The date value of {field} need to be more than {date}',
    invalid_minimum_than: '%{field} needs minimum %{value}',
    invalid_minimun_phone: 'Must inform one phone at least',
    invalid_minimun_address: 'Must inform one address at least',
    invalid_min_character: 'Must be more than %{value} character',
    invalid_max_character: 'Can\'t be more than %{value} character',
    choose_one_option: 'Choose one option in "%{field}"',
    doubleclick_for_edit: 'Double click to edit',
    loading: 'Loading ...',
    error_image_size: 'File can not be larger than 1024KB',
    empty: 'No data',
    no_items_selected: 'No items selected.',
    invalid_maximumTimeIdeal: 'Maximum real time can\'t be more than ideal time.',
    document_sent: 'Document sent !',
  },
  permissions: {
    write: 'Save',
    list: 'View',
    remove: 'Delete',
    change: 'Change Password',
    change_password: 'Change Password',
    activate: 'Activate',
    standby: 'StandBy',
    block: 'Block',
    unblock: 'Unblock',
    inactivate: 'Inactivate',
  },
  titles: {
    new_workflow: 'Create new Workflow',
    phase_creation: 'Create Phase',
    uncompleted_workflow: 'Uncompleted Workflow',
  },
  tableList: {

    // for filter panel
    page: 'Page',
    more: 'More',
    to: 'to',
    of: 'of',
    next: 'Next',
    last: 'Last',
    first: 'First',
    previous: 'Previous',
    loadingOoo: 'Loading ...',

    // for set filter
    selectAll: 'Select All',
    searchOoo: 'Searching ...',
    blanks: 'Blanks',

    // for number filter and text filter
    filterOoo: 'Filtering ...',
    applyFilter: 'Applying Filter ...',

    // for number filter
    equals: 'Equals',
    lessThan: 'Less than',
    greaterThan: 'Greater than',

    // for text filter
    contains: 'Contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',

    // the header of the default group column
    group: 'Group',

    // tool panel
    columns: 'Columns',
    rowGroupColumns: 'Pivot Cols',
    rowGroupColumnsEmptyMessage: ' drag cols to group',
    valueColumns: 'Value Cols',
    pivotMode: 'Pivot-Mode',
    groups: 'Groups',
    values: 'Values',
    pivots: 'Pivots',
    valueColumnsEmptyMessage: ' drag cols to aggregate',
    pivotColumnsEmptyMessage: ' drag here to pivot',

    // other
    noRowsToShow: ' no rows',


    // enterprise menu
    pinColumn: 'Pin Column',
    valueAggregation: 'Value Agg',
    autosizeThiscolumn: 'Autosize Diz',
    autosizeAllColumns: 'Autsoie em All',
    groupBy: 'Group by',
    ungroupBy: 'UnGroup by',
    resetColumns: 'Reset Those Cols',
    expandAll: 'Open-em-up',
    collapseAll: 'Close-em-up',
    toolPanel: 'Tool Panelo',

    // enterprise menu pinning
    pinLeft: 'Pin <<',
    pinRight: 'Pin >>',
    noPin: 'DontPin <>',

    // enterprise menu aggregation and status panel
    sum: 'Sum',
    min: 'Min',
    max: 'Max',
    none: 'None',
    count: 'Count',
    average: 'Average',

    // standard menu
    copy: 'Copy',
    copyWithHeaders: 'Copy Wit hHeaders',
    ctrlC: 'ctrl n C',
    paste: 'Paste',
    ctrlV: 'ctrl n C',
  },

};



// WEBPACK FOOTER //
// ./src/i18n/en.js